import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen } from "@fortawesome/free-solid-svg-icons";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

function Non_Work_table({ onEdit }) {
  const data = [
    {
      date: "01 JAN 2025",
      recordNo: "22341",
      dateRaised: "01 JAN 2025",
      dept: "Lab Area",
      statement: "Statement Of Complaint",
      clause: "IEC 17025:2017",
      remark: "",
      status: "Pending",
    },
    {
      date: "02 JAN 2025",
      recordNo: "22342",
      dateRaised: "02 JAN 2025",
      dept: "Lab Area",
      statement: "Statement Of Complaint",
      clause: "IEC 17025:2017",
      remark: "",
      status: "Action Taken Report (ATR) Received",
    },
  ];

     const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <section className="Imperiality_table">
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped customer_table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Record No.</th>
                <th>Date Raised</th>
                <th>Dept./Area</th>
                <th>Non-Conformity Statement</th>
                <th>Clause / Document Violated</th>
                <th>Remark</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  <td>{row.date}</td>
                  <td>{row.recordNo}</td>
                  <td>{row.dateRaised}</td>
                  <td>{row.dept}</td>
                  <td>{row.statement}</td>
                  <td>{row.clause}</td>
                  <td>{row.remark || "---"}</td>

                  <td
                    className={
                      row.status === "Pending"
                        ? "status_pending"
                        : "status_completed"
                    }
                  >
                    {row.status}
                  </td>

                  <td>
                    <div className="action_icons">
                      <FontAwesomeIcon
                        icon={faPen}
                        onClick={onEdit}
                        style={{ cursor: "pointer" }}
                      />
                      <FontAwesomeIcon icon={faEye} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>

          </table>
        </div>
      </div>

       <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </section>
  );
}

export default Non_Work_table;
